// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__mBVTg","footer":"ModalCreateQualiphyProcedure_footer__nT_AJ","additionData":"ModalCreateQualiphyProcedure_additionData__Fha7l"};